import React, { useEffect, useState } from "react";
import PageHeader from "../../components/common/PageHeader";
import AboutSection from "../../components/Home/AboutSection";
import OurService from "../../components/Home/OurService";
import LatestServiceOffer from "../../components/common/LatestServiceOffer";
import AboutAndContactInfro from "../../components/About Us/AboutAndContactInfro";
import axiosInstance from "../../utils/axios";

const About = () => {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchServices = async () => {
      try {
        setLoading(true);
        const res = await axiosInstance.get("/services/all");
        setServices(res.data);
      } catch (error) {
        console.error("Error fetching services:", error.message);
      } finally {
        setLoading(false);
      }
    };
    fetchServices();
  }, []);
  return (
    <div>
      <div className="pb-10">
        <PageHeader title="About Us" />
      </div>
      <AboutSection />
      <OurService services={services.slice(0, 4)} loading={loading} />
      <AboutAndContactInfro />
      <LatestServiceOffer />
    </div>
  );
};

export default About;
